<template>
  <div class="section grid-view">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item required :label="$t('Partners.DriverName')">
            <el-input v-model="editDialog.form.driverName" no="driverName" />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultDriver" no="defaultDriver" @change="onDefaultChange">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Partners.DriverPhoneNumber')">
            <el-input v-model="editDialog.form.driverPhone" no="driverPhone" />
          </el-form-item>
          <el-form-item :label="$t('Partners.PlateNumber')">
            <el-input v-model="editDialog.form.plateNumber" no="plateNumber" />
          </el-form-item>
          <el-form-item :label="$t('Partners.IdentityCard')">
            <el-input v-model="editDialog.form.driverIdCard" no="driverIdCard" />
          </el-form-item>
          <el-form-item :label="$t('Partners.remark')">
            <el-input v-model="editDialog.form.remark" no="remark" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_DeliveryArea')">
            <el-input v-model="editDialog.form.deliveryArea" no="deliveryArea" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { AutoIncrementNum } from '@/utils/commonUtil'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'DriverInformationForm',
  components: { CargoOwnedBranchSelect, CargoCompanySelect, CargoRichTextarea, cargoInput, cargoAdvanceSelect, cargoUserSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        companyUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          checkboxSelection: true,
          width: 100,
          headerCheckboxSelection: true,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false

        }, {
          headerName: this.$t('Partners.DriverName'),
          field: 'driverName',
          width: 300
        }, {
          headerName: this.$t('Partners.DriverPhoneNumber'),
          field: 'driverPhone',
          width: 300
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultDriver',
          width: 200,
          cellRenderer: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        },
        {
          headerName: this.$t('Partners.PlateNumber'),
          field: 'plateNumber',
          width: 300
        },
        {
          headerName: this.$t('Partners.IdentityCard'),
          field: 'driverIdCard',
          width: 300
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeliveryArea'),
          field: 'deliveryArea',
          width: 300
        },
        {
          headerName: this.$t('Partners.remark'),
          field: 'remark',
          width: 300
        }
      ],
      rowData: [],
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          driverName: '',
          driverPhone: '',
          defaultDriver: false,
          plateNumber: '',
          driverIdCard: '',
          remark: '',
          deliveryArea: '',
          companyUuid: ''
        }
      },
      deleteDriverInformationKeys: [],
      autoIncrementNum: new AutoIncrementNum(),
      selectedNode: null,
      company: {}
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    readonly() {
      return !this.action || this.action === 'look'
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.company = row
        this.rowData = row.driverInformationList || []
        if (this.rowData && this.rowData.length > 0) {
          this.rowData.forEach(p => {
            p.seq = this.autoIncrementNum.getNextNum()
          })
        }
        this.deleteDriverInformationKeys = []
      }
    },
    getSubmitData() {
      return {
        driverInformationList: this.rowData,
        deleteDriverInformationKeys: this.deleteDriverInformationKeys
      }
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          driverName: '',
          driverPhone: '',
          defaultDriver: false,
          plateNumber: '',
          driverIdCard: '',
          deliveryArea: '',
          remark: '',
          companyUuid: this.company.uuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        // 第一个新增的默认为是，允许修改
        if (this.rowData.length === 0) {
          this.editDialog.form.defaultDriver = true
        } else {
          let hasDefault = false
          for (const driver of this.rowData) {
            if (driver.defaultDriver) {
              hasDefault = true
              break
            }
          }
          this.editDialog.form.defaultDriver = !hasDefault
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        if (!this.selectedRow) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...this.selectedRow }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    async save() {
      const form = this.editDialog.form
      // 基本格式校验
      if (StrUtils.isEmpty(form.driverName)) {
        this.$message.warning(this.$t('Partners.DriverNameRequired'))
        return
      }
      // 判断是否要设置为默认联系人
      if (form.defaultDriver) {
        const existItem = this.rowData.find(p => p.defaultDriver && p.seq !== form.seq)
        if (existItem) {
          existItem.defaultDriver = false
        }
      } else {
        const existItem = this.rowData.find(p => !!p.defaultDriver)
        if (!existItem) {
          form.defaultDriver = true
        }
      }
      // 数据暂存
      const row = this.rowData.find(item => item.seq === form.seq)
      if (row) {
        Object.assign(row, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      this.editDialog.visible = false
    },
    remove() {
      const row = this.selectedRow
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        if (index >= 0) {
          this.rowData.splice(index, 1)
          if (row.uuid) {
            this.deleteDriverInformationKeys.push(row.uuid)
          }
        }
      }).catch(() => { })
    },
    onDefaultChange() {
      const form = this.editDialog.form
      if (form.defaultDriver) {
        const existItem = this.rowData.find(p => p.defaultDriver && p.seq !== form.seq)
        if (existItem) {
          this.$message.warning(this.$t('Partners.alreadyDefaultContact'))
        }
      }
    }
  }
}
</script>

<style>
</style>
